import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveSceneDsLink } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

export enum DsLinkState {
	FRESH = 'fresh', // latest publish state matches currently loaded state, and no draft exists -- as fresh as it gets!
	DRAFT_EXISTS = 'draftExists',
	PUBLISHING = 'publishing',
	STALE = 'stale', // there's a newer published version available that we're not using
}

// returns the state of the link between the active scene and its design system
const useDsLinkState = (): DsLinkState => {
	const dsLink = useSelector((r: RootReducer) => selectActiveSceneDsLink(r.db));

	return useMemo(() => {
		if (!dsLink) return DsLinkState.FRESH;
		const { linkedVersion, latestPublishedVersion, hasDraft } = dsLink;
		const promptStatus = latestPublishedVersion.manifest?.promptGenerationStatus;
		if (promptStatus === 'pending' || promptStatus === 'generating') {
			return DsLinkState.PUBLISHING;
		}
		if (linkedVersion.versionNumber < latestPublishedVersion.versionNumber && promptStatus === 'complete') {
			return DsLinkState.STALE;
		}
		if (hasDraft) return DsLinkState.DRAFT_EXISTS;
		return DsLinkState.FRESH;
	}, [dsLink]);
};

export default useDsLinkState;
